import { createFileRoute } from "@tanstack/react-router";

import ServicePrincipalsAdmin from "@/components/ServicePrincipalsAdmin";

// Generated to match `src/app/admin/service-principals/page.tsx`. The route is a passthrough: the console
// component owns everything, and `admin/route.tsx` owns the shell and the gate.
export const Route = createFileRoute("/admin/service-principals")({
  component: ServicePrincipalsAdmin,
});
